import { render, staticRenderFns } from "./MasterBox.vue?vue&type=template&id=35befce0&scoped=true&"
import script from "./MasterBox.vue?vue&type=script&lang=js&"
export * from "./MasterBox.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=35befce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35befce0",
  null
  
)

export default component.exports